<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon class="m-2" icon="edit-outline" *ngIf="action === 'edit'"></nb-icon>
        <nb-icon class="m-2" icon="plus-outline" *ngIf="action !== 'edit'"></nb-icon>
        <div *ngIf="action === 'edit'" i18n>Editing Survey: {{ survey.survey_id }}</div>
        <div *ngIf="action === 'clone'" i18n>Cloning Survey</div>
        <div *ngIf="action === 'create'" i18n>Creating Survey</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <form [formGroup]="surveyForm" (ngSubmit)="onSubmit()">
      <!-- Survey Form -->
      <br />

      <div class="row">
        <div class="col-4">
          <label i18n>Survey ID<span style="color: red">*</span>:</label>
        </div>
        <div class="col-8">
          <input nbInput placeholder="Survey ID" i18n-placeholder style="width: 100%" formControlName="survey_id" />
          <div *ngIf="surveyForm.get('survey_id').hasError('pattern')">
            <p class="error" i18n>ID allows alphanumeric characters, underscore and colon.</p>
          </div>
        </div>
      </div>
      <br />

      <div class="row">
        <div class="col-4">
          <label i18n>Survey Name<span style="color: red">*</span>:</label>
        </div>
        <div class="col-8">
          <input nbInput placeholder="Survey Name" i18n-placeholder style="width: 100%" formControlName="survey_name" />
        </div>
      </div>
      <br />
      <!-- Questions Form -->
      <div formArrayName="questions">
        <div *ngFor="let question of questions().controls; let qi = index">
          <div [formGroupName]="qi">
            <br />
            <nb-accordion>
              <nb-accordion-item>
                <nb-accordion-item-header (click)="$event.stopPropagation()">
                  <div class="col-auto mr-auto">
                    <label *ngIf="survey.questions[qi]?.question_id" i18n>
                      Question: {{ survey.questions[qi].question_id }}
                    </label>
                    <label *ngIf="!survey.questions[qi]?.question_id" i18n> Question {{ [qi + 1] }} </label>
                  </div>
                  <div class="col-auto" style="padding-right: 40px">
                    <button
                      nbTooltip="Delete Question"
                      i18n-nbTooltip
                      nbButton
                      size="small"
                      status="danger"
                      (click)="removeQuestion(qi)"
                    >
                      <nb-icon icon="trash-2-outline"></nb-icon>
                    </button>
                  </div>
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                  <nb-card>
                    <nb-card-body>
                      <div class="row">
                        <div class="col-4"><label i18n>Visible</label></div>
                        <div class="col-8">
                          <nb-checkbox formControlName="visible"></nb-checkbox>
                        </div>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-4">
                          <label i18n>Question ID<span style="color: red">*</span>:</label>
                        </div>
                        <div class="col-8">
                          <input
                            nbInput
                            placeholder="Question ID"
                            i18n-placeholder
                            style="width: 100%"
                            formControlName="question_id"
                          />
                          <div *ngIf="question.get('question_id').hasError('pattern')">
                            <p class="error" i18n>ID allows alphanumeric characters, underscore and colon.</p>
                          </div>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-4">
                          <label i18n>Question Type<span style="color: red">*</span>:</label>
                        </div>
                        <div class="col-8">
                          <nb-select
                            placeholder="Question Type"
                            i18n-placeholder
                            formControlName="question_type"
                            style="width: 100%"
                          >
                            <nb-option *ngFor="let question of questionType" [value]="question">
                              {{ question }}
                            </nb-option>
                          </nb-select>
                        </div>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-4"><label i18n>Question Name:</label></div>
                        <div class="col-8">
                          <input
                            formControlName="question_name"
                            nbInput
                            placeholder="Question Name"
                            i18n-placeholder
                            style="width: 100%"
                          />
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-4"><label i18n>Question Image ID:</label></div>
                        <div class="col-8">
                          <input
                            formControlName="image_id"
                            nbInput
                            placeholder="Question Image ID"
                            i18n-placeholder
                            style="width: 100%"
                          />
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-4"><label i18n>Question Title Text:</label></div>
                        <div class="col-8">
                          <input
                            formControlName="value"
                            nbInput
                            placeholder="Question Title Text"
                            i18n-placeholder
                            style="width: 100%"
                          />
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-4"><label i18n>Question Title ID:</label></div>
                        <div class="col-8">
                          <input
                            formControlName="title_id"
                            nbInput
                            placeholder="Question Title ID"
                            i18n-placeholder
                            style="width: 100%"
                          />
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-4"><label i18n>Question Subtitle ID:</label></div>
                        <div class="col-8">
                          <input
                            formControlName="subtitle_id"
                            nbInput
                            placeholder="Question Subtitle ID"
                            i18n-placeholder
                            style="width: 100%"
                          />
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-4"><label i18n>Question Display Order:</label></div>
                        <div class="col-8">
                          <input
                            formControlName="display_order"
                            nbInput
                            type="number"
                            placeholder="Question Display Order"
                            i18n-placeholder
                            style="width: 100%"
                          />
                        </div>
                      </div>

                      <!-- Answers Form-->
                      <div formArrayName="answers">
                        <div *ngFor="let answer of answers(qi).controls; let ai = index">
                          <div [formGroupName]="ai">
                            <nb-accordion>
                              <nb-accordion-item>
                                <nb-accordion-item-header (click)="$event.stopPropagation()">
                                  <div class="col-auto mr-auto">
                                    <label *ngIf="survey.questions[qi]?.answers[ai]?.answer_id" i18n>
                                      Answer: {{ survey.questions[qi].answers[ai].answer_id }}
                                    </label>
                                    <label *ngIf="!survey.questions[qi]?.answers[ai]?.answer_id" i18n>
                                      Answer {{ [ai + 1] }}
                                    </label>
                                  </div>
                                  <div class="col-auto" style="padding-right: 40px">
                                    <button
                                      nbTooltip="Delete Answer"
                                      i18n-nbTooltip
                                      nbButton
                                      size="small"
                                      status="danger"
                                      (click)="removeAnswer(qi, ai)"
                                    >
                                      <nb-icon icon="trash-2-outline"></nb-icon>
                                    </button>
                                  </div>
                                </nb-accordion-item-header>
                                <nb-accordion-item-body>
                                  <nb-card>
                                    <nb-card-body>
                                      <div class="row">
                                        <div class="col-4">
                                          <label i18n>Answer ID<span style="color: red">*</span>:</label>
                                        </div>
                                        <div class="col-8">
                                          <input
                                            nbInput
                                            placeholder="Answer ID"
                                            i18n-placeholder
                                            style="width: 100%"
                                            formControlName="answer_id"
                                          />
                                          <div *ngIf="answer.get('answer_id').hasError('pattern')">
                                            <p class="error" i18n>
                                              ID allows alphanumeric characters, underscore and colon.
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      <br />

                                      <br />
                                      <div class="row">
                                        <div class="col-4">
                                          <label i18n>Answer Type:</label>
                                        </div>
                                        <div class="col-8">
                                          <nb-select
                                            placeholder="Answer Type"
                                            i18n-placeholder
                                            formControlName="answer_type"
                                            style="width: 100%"
                                          >
                                            <nb-option *ngFor="let answer of answerType" [value]="answer">
                                              {{ answer }}
                                            </nb-option>
                                          </nb-select>
                                        </div>
                                      </div>
                                      <br />

                                      <div class="row">
                                        <div class="col-4"><label i18n>Value:</label></div>
                                        <div class="col-8">
                                          <input
                                            nbInput
                                            placeholder="Answer Value"
                                            i18n-placeholder
                                            style="width: 100%"
                                            formControlName="value"
                                          />
                                        </div>
                                      </div>
                                      <br />

                                      <div class="row">
                                        <div class="col-4"><label i18n>Value ID:</label></div>
                                        <div class="col-8">
                                          <input
                                            nbInput
                                            placeholder="Answer Value ID"
                                            i18n-placeholder
                                            style="width: 100%"
                                            formControlName="value_id"
                                          />
                                        </div>
                                      </div>
                                      <br />

                                      <div class="row">
                                        <div class="col-4"><label i18n>Minimum Value:</label></div>
                                        <div class="col-8">
                                          <input
                                            nbInput
                                            placeholder="Minimum Value"
                                            i18n-placeholder
                                            style="width: 100%"
                                            formControlName="min_value"
                                          />
                                        </div>
                                      </div>
                                      <br />

                                      <div class="row">
                                        <div class="col-4"><label i18n>Minimum Value Description:</label></div>
                                        <div class="col-8">
                                          <input
                                            nbInput
                                            placeholder="Minimum Value Description"
                                            i18n-placeholder
                                            style="width: 100%"
                                            formControlName="min_value_text"
                                          />
                                        </div>
                                      </div>
                                      <br />

                                      <div class="row">
                                        <div class="col-4"><label i18n>Maximum Value:</label></div>
                                        <div class="col-8">
                                          <input
                                            nbInput
                                            placeholder="Maximum Value"
                                            i18n-placeholder
                                            style="width: 100%"
                                            formControlName="max_value"
                                          />
                                        </div>
                                      </div>
                                      <br />

                                      <div class="row">
                                        <div class="col-4"><label i18n>Maximum Value Description:</label></div>
                                        <div class="col-8">
                                          <input
                                            nbInput
                                            placeholder="Maximum Value Description"
                                            i18n-placeholder
                                            style="width: 100%"
                                            formControlName="max_value_text"
                                          />
                                        </div>
                                      </div>
                                      <br />

                                      <div class="row">
                                        <div class="col-4"><label i18n>Answer Image ID:</label></div>
                                        <div class="col-8">
                                          <input
                                            nbInput
                                            placeholder="Answer Image ID"
                                            i18n-placeholder
                                            style="width: 100%"
                                            formControlName="image_id"
                                          />
                                        </div>
                                      </div>
                                      <br />
                                      <br />

                                      <!-- Actions Form -->
                                      <div formArrayName="actions">
                                        <div *ngFor="let action of actions(qi, ai).controls; let aci = index">
                                          <div [formGroupName]="aci">
                                            <nb-accordion>
                                              <nb-accordion-item>
                                                <nb-accordion-item-header (click)="$event.stopPropagation()">
                                                  <div class="col-auto mr-auto">
                                                    <label
                                                      *ngIf="
                                                        survey.questions[qi]?.answers[ai]?.actions[aci]?.action_type
                                                      "
                                                      i18n
                                                    >
                                                      Action:
                                                      {{ survey.questions[qi]?.answers[ai]?.actions[aci]?.action_type }}
                                                    </label>
                                                    <label
                                                      *ngIf="
                                                        !survey.questions[qi]?.answers[ai]?.actions[aci]?.action_type
                                                      "
                                                      i18n
                                                    >
                                                      Action {{ [aci + 1] }}
                                                    </label>
                                                  </div>
                                                  <div class="col-auto" style="padding-right: 40px">
                                                    <button
                                                      nbTooltip="Delete Action"
                                                      i18n-nbTooltip
                                                      nbButton
                                                      size="small"
                                                      status="danger"
                                                      (click)="removeAction(qi, ai, aci)"
                                                    >
                                                      <nb-icon icon="trash-2-outline"></nb-icon>
                                                    </button>
                                                  </div>
                                                </nb-accordion-item-header>
                                                <nb-accordion-item-body>
                                                  <br />
                                                  <div class="row">
                                                    <div class="col-4">
                                                      <label i18n>Action Type<span style="color: red">*</span>:</label>
                                                    </div>
                                                    <div class="col-8">
                                                      <nb-select
                                                        placeholder="Action Type"
                                                        i18n-placeholder
                                                        formControlName="action_type"
                                                        style="width: 100%"
                                                      >
                                                        <nb-option
                                                          *ngFor="let actionType of actionTypes"
                                                          [value]="actionType"
                                                        >
                                                          {{ actionType }}
                                                        </nb-option>
                                                      </nb-select>
                                                    </div>
                                                  </div>
                                                  <br />

                                                  <div class="row">
                                                    <div class="col-4"><label i18n>Action Value:</label></div>
                                                    <div class="col-8">
                                                      <input
                                                        nbInput
                                                        placeholder="Action Value"
                                                        i18n-placeholder
                                                        style="width: 100%"
                                                        formControlName="action_value"
                                                      />
                                                    </div>
                                                  </div>
                                                  <br />

                                                  <strong class="text-uppercase" i18n>Action Payload</strong>

                                                  <div formGroupName="action_payload">
                                                    <div class="row">
                                                      <div class="col-4"><label i18n>Deleted</label></div>
                                                      <div class="col-8">
                                                        <nb-checkbox formControlName="deleted"></nb-checkbox>
                                                      </div>
                                                    </div>
                                                    <br />

                                                    <div class="row">
                                                      <div class="col-4"><label i18n>URL:</label></div>
                                                      <div class="col-8">
                                                        <input
                                                          nbInput
                                                          placeholder="URL"
                                                          i18n-placeholder
                                                          style="width: 100%"
                                                          formControlName="url"
                                                        />
                                                      </div>
                                                    </div>
                                                    <br />
                                                  </div>
                                                </nb-accordion-item-body>
                                              </nb-accordion-item>
                                            </nb-accordion>
                                          </div>
                                          <br />
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-auto">
                                          <button
                                            nbTooltip="Create New Action"
                                            i18n-nbTooltip
                                            nbButton
                                            size="small"
                                            type="button"
                                            status="success"
                                            (click)="addAction(qi, ai)"
                                            i18n
                                          >
                                            <nb-icon icon="plus-square-outline"></nb-icon>New Action
                                          </button>
                                        </div>
                                      </div>
                                    </nb-card-body>
                                  </nb-card>
                                </nb-accordion-item-body>
                              </nb-accordion-item>
                            </nb-accordion>
                          </div>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-auto">
                          <button
                            nbButton
                            nbTooltip="Create New Answer"
                            i18n-nbTooltip
                            size="small"
                            type="button"
                            status="success"
                            (click)="addAnswer(qi)"
                            i18n
                          >
                            <nb-icon icon="plus-square-outline"></nb-icon>New Answer
                          </button>
                        </div>
                      </div>
                      <br />
                    </nb-card-body>
                  </nb-card>
                </nb-accordion-item-body>
              </nb-accordion-item>
            </nb-accordion>
          </div>
        </div>
      </div>

      <br />
      <div class="row">
        <div class="col-auto">
          <button
            nbButton
            nbTooltip="Create New Question"
            i18n-nbTooltip
            size="small"
            status="success"
            type="button"
            (click)="addQuestion()"
            i18n
          >
            <nb-icon icon="plus-square-outline"></nb-icon>New Question
          </button>
        </div>
      </div>
      <br />
    </form>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton class="ml-3" status="success" (click)="onSubmit()" [disabled]="!surveyForm.valid" i18n>
        Save
      </button>
    </div>
  </nb-card-footer>
</nb-card>
